// extracted by mini-css-extract-plugin
export default {"rating":"yz-z","numberOfStars":"zz-z","count":"Az-z","barGraphSpacing":"Bz-z","barGraph":"Cz-z"};